import { render } from "./VideoChat.vue?vue&type=template&id=44231834&scoped=true"
import script from "./VideoChat.vue?vue&type=script&lang=js"
export * from "./VideoChat.vue?vue&type=script&lang=js"

import "./VideoChat.scss?vue&type=style&index=0&id=44231834&lang=scss&scoped=true"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44231834"]])

export default __exports__